import React, { useRef, useState } from 'react';

import { Loading, Input } from 'antd';

import { AgGrid, StyledModal } from 'common/components';

import { mappingColumns } from 'common/components/product-subscription/utils';

import * as endpoints from 'services/mapping/endpoints';

const ProductSubscriptionMappingModal = (props) => {
  const gridApi = useRef(null);

  const { visible, onOk, onCancel } = props;

  const [searchText, setSearchText] = useState('');

  const handleAddMapping = () => {
    const selectedRows = gridApi?.current?.getSelectedRows();

    if (selectedRows?.length <= 0) return;

    const firstSelectedRow = gridApi.current.getSelectedRows()[0];

    onOk && onOk(firstSelectedRow);
  };

  const modalProps = {
    visible: visible,
    title: 'Select Mapping',
    onCancel: onCancel,
    onOk: handleAddMapping,
    okText: 'Add',
    maskClosable: false,
    width: '600px',
    destroyOnClose: true,
    bodyStyle: { minHeight: '70vh' },
  };

  return (
    <StyledModal {...modalProps}>
      <div style={{ height: '430px', marginBottom: 40 }}>
        <>
          <div style={{ display: 'flex', marginBottom: 10 }}>
            <Input.Search
              placeholder='Search mapping'
              allowClear
              onSearch={(value) => setSearchText(value)}
            />
          </div>
          <AgGrid
            columnDefs={mappingColumns}
            urlGrid={endpoints.GET_SUB_MAPPING_GRID}
            responseParams='data'
            gridConfigProps={{
              rowSelection: 'single',
            }}
            getGridApi={(api) => {
              gridApi.current = api;
            }}
            paramsGrid={{
              search: {
                searchText,
              },
              enableRivirDownload: true,
            }}
          />
        </>
      </div>
    </StyledModal>
  );
};

export default ProductSubscriptionMappingModal;
